const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000/api';

export interface ApiGalleryImage {
  id: number;
  url: string;
  thumb: string;
}

export interface ApiGalleryAlbum {
  id: number;
  title: string;
  slug: string;
  description: string | null;
  event_date: string | null;
  images: ApiGalleryImage[];
}

export async function fetchGalleryAlbums(): Promise<ApiGalleryAlbum[]> {
  const res = await fetch(`${API_URL}/gallery`);

  if (!res.ok) {
    throw new Error('Failed to load gallery');
  }

  return res.json();
}
